//icons
import { GiMoneyStack } from "react-icons/gi";
import { AiOutlineHome, AiOutlinePieChart, AiOutlineTeam } from "react-icons/ai";
import { VscTypeHierarchySub } from "react-icons/vsc";
import { GiPartyPopper } from "react-icons/gi";
import { FiUsers } from "react-icons/fi";
import { TfiAnnouncement } from "react-icons/tfi";
import { CiCalendarDate } from "react-icons/ci";
import { RiOrganizationChart, RiTimerFlashLine } from "react-icons/ri";
import { IoFingerPrintOutline } from "react-icons/io5";
import { TbReportSearch, TbReportMoney } from "react-icons/tb";
import { HiOutlinePresentationChartLine } from "react-icons/hi";
import { CgUserList } from "react-icons/cg";
import { IoMdSettings } from "react-icons/io";
import { BsStars } from "react-icons/bs";
import { FaBusinessTime } from "react-icons/fa";
import { LuTimerReset, LuPlusCircle, LuMinusCircle } from "react-icons/lu";

const SidebarLinks = [
  {
    id: 1,
    groupTitle: "",
    name: "الرئيسية",
    icon: <AiOutlineHome size={18} />,
    path: "/",
    sub: [],
    allowAll: true,
  },
  // ================== المجموعة: الأساسية ==================
  {
    id: 2,
    groupTitle: "الأحصائيات و التقارير",
    name: " الاحصائيات",
    icon: <HiOutlinePresentationChartLine size={20} />,
    path: "/statistics",
    sub: [],
    roles: [],
    permissionName: "statistics_view",
  },
  {
    id: 22,
    groupTitle: "الأحصائيات و التقارير",
    name: "تقييم أداء الموظفين",
    icon: <AiOutlinePieChart size={20} />,
    path: "/kpi",
    sub: [],
    roles: [],
    permissionName: "statistics_view",
  },
  {
    id: 13,
    groupTitle: "الأحصائيات و التقارير",
    name: "التقارير",
    icon: <TbReportSearch size={20} />,
    path: "/reports",
    sub: [],
    roles: [],
    permissionName: "reports_view",
  },

  // ================== المجموعة: إدارة الموظفين و الاقسام ==================
  {
    id: 3,
    groupTitle: "إدارة الموظفين و الاقسام",
    name: "الموظفين",
    icon: <FiUsers size={18} />,
    path: "/employee",
    sub: [],
    roles: [],
    permissionName: "user_view",
  },
  {
    id: 19,
    groupTitle: "إدارة الموظفين و الاقسام",
    name: "تقييم الموظفين",
    icon: <BsStars size={18} />,
    path: "/employee-ratings",
    sub: [],
    roles: ["user"],
    has_team_required: true,
    permissionName: "evaluation_view",
  },
  {
    id: 62,
    groupTitle: "إدارة الموظفين و الاقسام",
    name: "اعضاء الفريق",
    icon: <AiOutlineTeam size={18} />,
    path: "/team-leader",
    sub: [],
    roles: ["user"],
    has_team_required: true,
  },
  {
    id: 20,
    groupTitle: "إدارة الموظفين و الاقسام",
    name: "الهيكل الإداري",
    icon: <RiOrganizationChart size={20} />,
    path: "/company-tree",
    sub: [],
    roles: [],
    permissionName: "tree_department_view",
  },
  {
    id: 7,
    groupTitle: "إدارة الموظفين و الاقسام",
    name: "الأقسام",
    icon: <VscTypeHierarchySub size={18} />,
    path: "/departments",
    sub: [],
    roles: [],
    permissionName: "department_view",
  },

  // ================== المجموعة: الدوام والحضور ==================
  {
    id: 6,
    groupTitle: "الدوام والحضور",
    name: "الحضور و الأنصراف",
    icon: <IoFingerPrintOutline size={18} />,
    path: "/attendance",
    sub: [],
    roles: ["user"],
    has_team_required: true,
    permissionName: "attendance_view",
  },
  {
    id: 5,
    groupTitle: "الدوام والحضور",
    name: "بصماتي",
    icon: <IoFingerPrintOutline size={18} />,
    path: "/my-attendance",
    sub: [],
    allowAll: true,
  },
  {
    id: 4,
    groupTitle: "الدوام والحضور",
    name: "تغيير الشفت",
    icon: <CgUserList size={18} />,
    path: "/shifts",
    sub: [],
    roles: [],
    permissionName: "change_shift_view",
  },
  {
    id: 10,
    groupTitle: "الدوام والحضور",
    name: "اوقات السماح",
    icon: <RiTimerFlashLine size={20} />,
    path: "/flexibility",
    sub: [],
    roles: [],
    permissionName: "flexibility_view",
  },
  {
    id: 9,
    groupTitle: "الدوام والحضور",
    name: "العطلات",
    icon: <GiPartyPopper size={20} />,
    path: "/holidays",
    sub: [],
    roles: [],
    permissionName: "holiday_view",
  },
  {
    id: 11,
    groupTitle: "الدوام والحضور",
    name: "الآجازات",
    icon: <CiCalendarDate size={20} />,
    path: "/leave",
    sub: [],
    allowAll: true,
  },
  {
    id: 21,
    groupTitle: "الدوام والحضور",
    name: "طلب دوام اونلاين",
    icon: <CiCalendarDate size={20} />,
    path: "/remotely-extra",
    sub: [],
    allowAll: true,
  },

  // ================== المجموعة: المالية والرواتب ==================
  {
    id: 16,
    groupTitle: "المالية والرواتب",
    name: "الرواتب",
    icon: <GiMoneyStack size={20} />,
    path: "/salary",
    sub: [],
    roles: [],
    permissionName: "salary_view",
  },
  {
    id: 17,
    groupTitle: "المالية والرواتب",
    name: "ادارة الرواتب",
    icon: <GiMoneyStack size={20} />,
    path: "/manage-salary",
    sub: [],
    roles: [],
    permissionName: "salary_view",
  },
  {
    id: 15,
    groupTitle: "المالية والرواتب",
    name: "القروض",
    icon: <TbReportMoney size={20} />,
    path: "/advance-payment",
    sub: [],
    roles: [],
    permissionName: "advance_payment_view",
  },
  {
    id: 14,
    groupTitle: "المالية والرواتب",
    name: "المكافئات",
    icon: <LuPlusCircle size={20} />,
    path: "/bonuses",
    sub: [],
    allowAll: true,
  },
  {
    id: 142,
    groupTitle: "المالية والرواتب",
    name: "الأنذارات و الخصومات",
    icon: <LuMinusCircle size={20} />,
    path: "/cuts",
    sub: [],
    allowAll: true,
  },
  {
    id: 678,
    groupTitle: "المالية والرواتب",
    name: "الاوقات الاضافية",
    icon: <LuTimerReset size={20} />,
    path: "/suspension-overtime",
    sub: [],
    roles: ["user"],
    has_team_required: true,
    permissionName: "suspension_over_time_view",
  },
  {
    id: 140,
    groupTitle: "المالية والرواتب",
    name: "مكافئات الساعات الاضافية",
    icon: <FaBusinessTime size={20} />,
    path: "/overtime",
    sub: [],
    allowAll: true,
  },

  // ================== المجموعة: النظام والإعدادات ==================
  {
    id: 8,
    groupTitle: "النظام والإعدادات",
    name: "الإعلانات",
    icon: <TfiAnnouncement size={18} />,
    path: "/announcements",
    sub: [],
    roles: [],
    permissionName: "announcement_view",
  },
  {
    id: 12,
    groupTitle: "النظام والإعدادات",
    name: "التبليغات و الأشعارات",
    icon: <CiCalendarDate size={20} />,
    path: "/notifications",
    sub: [],
    allowAll: true,
  },
  {
    id: 18,
    groupTitle: "النظام والإعدادات",
    name: "الاعدادات",
    icon: <IoMdSettings size={20} />,
    path: "/settings",
    sub: [],
    roles: [],
    permissionName: "settings_view",
  },
];

export default SidebarLinks;
